import React, { useEffect } from "react"
import { observer, useLocalStore } from "mobx-react-lite"

import CollapsibleList from "./CollapsibleList"

export const CollapsibleContext = React.createContext<CollapsibleList | null>(
  null
)

export const CollapsibleContextProvider: React.FC<{
  eternal?: CollapsibleList
  singleActive?: boolean
}> = observer(({ eternal, singleActive = false, children }) => {
  const context = useLocalStore(
    () => eternal ?? new CollapsibleList({ singleActive })
  )

  useEffect(() => {
    context.setSingleActive(singleActive)
  }, [singleActive !== context.singleActive])

  return (
    <CollapsibleContext.Provider value={context}>
      {children}
    </CollapsibleContext.Provider>
  )
})

export default CollapsibleContextProvider
